import React from "react";
import { motion } from "framer-motion";
import PromoCard from "./PromoCard";

const PromoGrid = ({ promos = [], loading = false }) => {
  return (
    <section id="promo-list" className="py-16 md:py-24 bg-white">
      <div className="container mx-auto px-4">
        {/* HEADER */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="text-center mb-12 md:mb-16"
        >
          <span className="inline-block text-red-600 font-semibold mb-3">
            Promo Terbaik
          </span>
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Daftar Promo Honda
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto">
            Pilih promo yang sesuai dengan kebutuhan Anda.
          </p>
        </motion.div>

        {/* CONTENT */}
        {loading ? (
          <div className="text-center py-24 text-gray-400">
            Memuat promo...
          </div>
        ) : promos.length === 0 ? (
          <div className="text-center py-24">
            <p className="text-gray-400 text-lg font-medium">
              Promo tidak tersedia
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
            {Array.isArray(promos) &&
              promos.map((promo, index) => (
                <PromoCard
                  key={promo.id}
                  promo={promo}
                  index={index}
                />
              ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default PromoGrid;
